export default __webpack_public_path__ + "static/media/polaroid23.cc912990.jpg";